import React, { useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { Header } from "../components/Sidebar";
import { SearchCheck } from "lucide-react";

export default function Tracking() {
  const { setMobileOpen } = useOutletContext();
  const navigate = useNavigate();
  const [code, setCode] = useState("");

  const go = (e) => { e.preventDefault(); if (code.trim()) navigate(`/track/${code.trim().toUpperCase()}`); };

  return (
    <>
      <Header title="Tracking" subtitle="Consultá el estado de cualquier envío" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8">
        <div className="max-w-lg mx-auto bg-white rounded-xl border border-[#E2E8F0] p-8 shadow-sm text-center">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center"><SearchCheck className="h-7 w-7 text-[#3B82F6]" /></div>
          <h2 className="mt-4 text-xl font-bold text-[#0A1F44] font-display">Rastreá un envío</h2>
          <p className="text-sm text-[#64748B] mt-1">Ingresá el código (ej. PY-000001). El tracking público no requiere login.</p>
          <form onSubmit={go} className="mt-5 flex gap-2">
            <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="PY-000001" data-testid="track-code-input"
              className="flex-1 rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm font-mono outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-blue-100" />
            <button className="rounded-lg bg-[#0A1F44] hover:bg-[#132D5C] text-white font-semibold px-5 text-sm" data-testid="track-submit-btn">Buscar</button>
          </form>
        </div>
      </main>
    </>
  );
}
